import { createApp } from 'vue'
import App from './App.vue'
import router from '@/system/engine/router.js'
import ElementPlus from 'element-plus'
import Global from '@/system/store/global.js'

import '@element-plus/theme-chalk/dist/index.css'
import '@/assets/css/custom.css'

const app = createApp(App)

app.use(router)
app.use(ElementPlus)
app.use(Global)

app.mount('#app')
